export default __webpack_public_path__ + "static/media/camera_icon.c72f38a5.svg";